import type { OverlayTheme } from "../overlay-theme";

export const smallTitlesOverlay = {
    overlayName: "SmallTitlesOverlay",
    navBar: {
        largeTitleHeight: 0,
    },
} as OverlayTheme;
